import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { func, string, bool, number, oneOf } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './ActionIcon.css';

class ActionIcon extends Component {
  static propTypes = {
    icon: string,
    type: oneOf([
      '15',
      '20',
      '30',
      '40',
      '80',
      'navigation',
      'other',
      'social'
    ]),
    customClasses: string,
    withCircle: bool,
    disabled: bool,
    darkBg: bool,
    large: bool,
    black: bool,
    onClick: func.isRequired,
    exception: bool,
    text: string,
    notifications: number,
    href: string,
    responsive: bool
  };

  static defaultProps = {
    onClick: () => console.warn('Please provide a valid callback for the click event.'),
    text: '',
    customClasses: ''
  };

  state = { active: false };

  handleClick = e => {
    const { onClick, href } = this.props;

    this.setState({ active: !this.state.active });

    !href && onClick(e);
  }

  render() {
    const {
      icon,
      href,
      type,
      disabled,
      darkBg,
      withCircle,
      large,
      black,
      exception,
      text,
      customClasses,
      notifications,
      responsive,
      ...rest
    } = this.props;
    const { active } = this.state;
    const cx = classnames.bind(styles);
    const hasText = text.length > 0;
    const wrapperClasses = cx(styles.iconWrapper,
      {
        disabled,
        darkBg,
        active,
        withCircle,
        large,
        black,
        navigation: type === 'navigation',
        exception,
        withText: hasText,
        withNotifications: notifications
      }
    );
    const textClasses = cx(styles.text, { 'hotspot-title': large });
    const iconType = withCircle ? '15' : hasText ? '20' : type;

    return (
      <a
        href={href}
        className={classnames(wrapperClasses, customClasses)}
        onClick={this.handleClick}
        {...rest}
      >
        <Icon
          customClasses={styles.action}
          icon={icon}
          type={iconType}
          responsive={responsive}
        />
        { hasText && <p className={textClasses}>{text}</p> }
        {
          notifications
            && <span className={styles.notification}><p className={styles.notifications}>{notifications}</p></span>
        }
      </a>
    );
  }
}

export default ActionIcon;



// WEBPACK FOOTER //
// ./src/uis/elements/ActionIcons/ActionIcon.js